export default {
  nl: {
    languages: {
      label: 'Taal kiezen',
      current: 'Huidige taal: {language}',
      nl: 'Nederlands',
      en: 'Engels',
      fr: 'Frans',
      de: 'Duits',
    },
    meta: {
      title: 'VLECAD® Insights',
      description: 'VLECAD Insights geeft u een helder overzicht van uw productiegegevens.',
    },
  },
  en: {
    languages: {
      label: 'Choose language',
      current: 'Current language: {language}',
      nl: 'Dutch',
      en: 'English',
      fr: 'French',
      de: 'German',
    },
    meta: {
      title: 'VLECAD® Insights',
      description: 'VLECAD Insights gives you a clear overview of your production data.',
    },
  },
  fr: {
    languages: {
      label: 'Choisir la langue',
      current: 'Langue actuelle : {language}',
      nl: 'Néerlandais',
      en: 'Anglais',
      fr: 'Français',
      de: 'Allemand',
    },
    meta: {
      title: 'VLECAD® Insights',
      description: 'VLECAD Insights vous donne une vue claire de vos données de production.',
    },
  },
  de: {
    languages: {
      label: 'Sprache wählen',
      current: 'Aktuelle Sprache: {language}',
      nl: 'Niederländisch',
      en: 'Englisch',
      fr: 'Französisch',
      de: 'Deutsch',
    },
    meta: {
      title: 'VLECAD® Insights',
      description: 'VLECAD Insights bietet Ihnen einen klaren Überblick über Ihre Produktionsdaten.',
    },
  },
};
